import { ButtonPrimary } from '@/components/button'
import { Spinner } from '@/components/common'
import { ArrowBack, People, Person, UserIconFilled } from '@/components/icons'
import { ROUTE_EXTERNAL_SIGNUP, ROUTE_EXTERNAL_THIS_ACCOUNT_IS_ALREADY_TAKEN } from '@/constants/Routes'
import { useGetMatchHistoryUnauthenticated } from '@/services'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import ExternalScreen from './ExternalScreen'
import { HistoryMatches } from './components'

const LIMIT = 10
const OFFSET = 0

export const ClaimDetails = () => {
  const { t } = useTranslation()

  const { playerId, partnerId } = useParams()
  const location = useLocation()
  const navigate = useNavigate()

  const { data: matchHistory, isLoading: isMatchHistoryLoading } = useGetMatchHistoryUnauthenticated(
    Number(playerId),
    LIMIT,
    OFFSET
  )

  const goBack = () => {
    navigate(-1)
  }

  const onThisIsMeClick = () => {
    if (location.state.claimDetail.claimed) {
      navigate(`${ROUTE_EXTERNAL_THIS_ACCOUNT_IS_ALREADY_TAKEN}/${playerId}/${partnerId}`, {
        state: { claimDetail: location.state?.claimDetail },
      })
    } else {
      navigate(`${ROUTE_EXTERNAL_SIGNUP}/${partnerId}`, {
        state: { claimDetail: location.state?.claimDetail },
      })
    }
  }

  return (
    <ExternalScreen>
      <div className="w-full h-full bg-gradient-to-tr from-[#05155E] from-15% via-[#0163D0] to-[#4B97FE] flex flex-col gap-y-6 relative">
        <div className="flex flex-row items-center justify-between w-full text-white mt-6 px-4">
          <ArrowBack width={48} height={48} onClick={goBack} className="cursor-pointer" />
        </div>
        <div className="flex flex-row p-4 text-white gap-x-4 w-full">
          <div className="rounded-full">
            <div className="w-10 h-10 relative">
              <div className="absolute flex items-center justify-center">
                {location.state?.claimDetail?.imageUrl ? (
                  <img src={location.state?.claimDetail?.imageUrl} className="rounded-full w-10 h-10" alt="" />
                ) : (
                  <UserIconFilled className="w-10 h-10" />
                )}
              </div>
            </div>
          </div>
          {location.state?.claimDetail && (
            <div className="flex flex-col w-full justify-center truncate">
              <span className="font-semibold w-[80%] text-xl text-white truncate">
                {location.state?.claimDetail?.fullname}
              </span>
              <span className="text-white w-[80%] text-opacity-50 text-sm truncate">
                {location.state?.claimDetail?.age || 'N/A'} •{' '}
                {location.state?.claimDetail?.gender ? t(`player.${location.state?.claimDetail?.gender}`) : 'N/A'} •{' '}
                {location.state?.claimDetail?.shortAddress || 'N/A'}
              </span>
              <div className="flex gap-x-2">
                <div className="flex flex-row items-center gap-x-1 px-2 py-1 bg-white bg-opacity-10 rounded-lg">
                  <People />
                  <p className="text-xs">Doubles - {location.state?.claimDetail?.ratings?.doubles}</p>
                </div>
                <div className="flex flex-row items-center gap-x-1 px-2 py-1 bg-white bg-opacity-10 rounded-lg">
                  <Person />
                  <p className="text-xs">Singles - {location.state?.claimDetail?.ratings?.singles}</p>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="h-[519px] w-full bg-white rounded-t-3xl relative">
          <div className="w-full h-[400px] pl-2 pt-8 pb-2">
            <div className="w-full h-full py-[10px] px-4">
              <p className="text-navy-900 font-semibold text-base">Recent Matches</p>
              <div className="w-full h-full overflow-auto">
                {isMatchHistoryLoading && (
                  <div className="w-full h-full flex flex-col items-center justify-center">
                    <Spinner className="w-8 h-8 fill-white text-blue-600" />
                  </div>
                )}
                {matchHistory && !isMatchHistoryLoading && (
                  <HistoryMatches
                    matches={matchHistory.hits}
                    playerId={Number(playerId)}
                    singleRating={location.state?.claimDetail?.ratings?.singles}
                    doubleRating={location.state?.claimDetail?.ratings?.doubles}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="absolute bottom-0 w-full h-max-[100px] border-t-[0.5px] border-navy-900 border-opacity-10 px-4 pt-4 pb-9">
            <ButtonPrimary title="This is me" className="w-full px-5 py-[14px]" onClick={onThisIsMeClick} />
          </div>
        </div>
      </div>
    </ExternalScreen>
  )
}

export default ClaimDetails
